<template>
<div>
  <ul class="audit-label-list" v-if="!isProxy && !isSupple">
    <li v-for="(label, index) in corporateFeatureInfoLabels" :key=index>
      {{ label }}
    </li>
  </ul>
  <ul class="audit-label-list-old" v-if="isProxy || isSupple">
    <li v-for="(label, index) in corporateFeatureInfoLabels" :key=index>
      {{ label }}
    </li>
  </ul>
</div>
</template>

<script>

export default {
  props: {
    corporateFeatureInfoLabels: {},
    isProxy: {},
    isSupple: {},
  },
}
</script>